// extracted by mini-css-extract-plugin
export default {"invest":"Invest_invest__jxlye","left":"Invest_left__0i59j","right":"Invest_right__A-VUl","funds":"Invest_funds__xfRsb","currencies":"Invest_currencies__ydyqY"};